import { create } from 'zustand';

import { Perk } from '../perks.types';

type StoreState = {
  close: () => void;
  isOpen: boolean;
  open: (payload: { payload: Perk }) => void;
  payload: null | Perk;
};

export const popupStore = create<StoreState>()((set) => ({
  isOpen: false,
  payload: null,

  open: ({ payload }) => {
    set({ isOpen: true, payload });
  },

  close: () => {
    set({ isOpen: false, payload: null });
  },
}));
